module.exports = __webpack_public_path__ + "static/media/pic3@2x.504e4eab.png";